import { render, staticRenderFns } from "./ReplenishInfo.vue?vue&type=template&id=871fb654&scoped=true"
import script from "./ReplenishInfo.vue?vue&type=script&lang=js"
export * from "./ReplenishInfo.vue?vue&type=script&lang=js"
import style0 from "./ReplenishInfo.vue?vue&type=style&index=0&id=871fb654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871fb654",
  null
  
)

export default component.exports